import Vue from 'vue'
import VueRouter from 'vue-router'

import Template from '../views/Template.vue'
import Home from '../views/Home.vue'
import Users from "../views/Users.vue";
import Guides from '../views/Guides.vue'
import Promos from '../views/Promos.vue'
import PromosCustom from '../views/PromosCustom.vue'
import Dashboard from '../views/Dashboard.vue'
import Emails from '../views/Emails.vue'
import Login from '../views/Login.vue'
import PageNotFound from '../views/PageNotFound.vue'
import Transaction from '../views/Transaction.vue'
import Modal from '../views/Modal.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: Template,
        children: [
            {
                path: '/users',
                name: 'Users',
                component: Users,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/transaction',
                name: 'Transaction',
                component: Transaction,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/modal',
                name: 'Modal',
                component: Modal,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/',
                name: 'Home',
                component: Home,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/guides',
                name: 'Guides',
                component: Guides,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/promo',
                name: 'Promos',
                component: Promos,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/promo15-30',
                name: 'PromosCustom',
                component: PromosCustom,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/dashboard',
                name: 'Dashboard',
                component: Dashboard,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/emails',
                name: 'Емейлы',
                component: Emails,
                meta: {
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/auth',
        name: 'Login',
        component: Login,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '*',
        component: PageNotFound,
        meta: {
            requiresAuth: false
        }
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
